import { Directive, HostListener, Input, ElementRef } from '@angular/core';

@Directive({
  selector: '[appAllowStringNumeric]'
})
export class AllowStringNumericDirective {

  inputElement: HTMLElement;
  arabicRegex = '[\u0600-\u06FF]';
  keyArr = ["@","!","#","$","%","^","~","*","<",">","=","+","[","]",'"',"'","\"","`"];
  polkeyArr = ["@","!","#","$","%","^","~","*","<",">","=","+","|","{","}","(",")","[","]",'"',"'",";",":","?","-",",","'\'","`"," ","."];
  spkeyArr = ["@","!","#","$","%","^","~","*","<",">","=","+","|","{","}","(",")","[","]",'"',"'",";",":","?","-",",","'\'","`"," ",".",];
  @Input() appSpecialCharacter: boolean = false;
  @Input() isItPolicy: boolean = false;
  @Input() textArea: boolean = false;
  @Input() maxNumber: number = -1;
  constructor(private el: ElementRef) {
    this.inputElement = this.el.nativeElement
  }



 

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    let e = <KeyboardEvent>event;
    let k = e.keyCode;  // k = event.charCode;  (Both can be used)
   
    if (this.appSpecialCharacter) {
      if(k != 8){
        if(this.spkeyArr.indexOf(e.key) != -1){
          e.preventDefault();
        }
      }
      //this.noSpecialChars(e)
    }
    if(this.maxNumber != -1){
      if(k != 8){
      if(this.maxNumber-1 < String(this.el.nativeElement.value).length){
        e.preventDefault();
      }
    }
    }
    if(this.textArea){
      if(k != 8){
      if(this.keyArr.indexOf(e.key) != -1){
        e.preventDefault();
      }
    }
    }
    if(this.isItPolicy){
     
 
      if((k != 191 && k != 8) ){
        
          if(this.polkeyArr.indexOf(e.key) != -1){
            e.preventDefault();
          }
       
      }
      
     
    }
  }
  noSpecialChars(e) {
   

    if (e.key === 'Tab' || e.key === 'TAB' && String(e.key).toLowerCase()=='shift') {
      //e.preventDefault();
      return;
    }
    let k;
    k = e.keyCode;  // k = event.charCode;  (Both can be used)
    if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k >= 48 && k <= 57)) {
      e.preventDefault();
    }
    
  }

}
